module.exports = __webpack_public_path__ + "media/images/infos-323104bf289d40501aa989b5a99d3ded.svg";